import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';

function getPrescriptionGlassesDetails(prescription) {
    switch(prescription.type){
        case 'email-prescription':
            return {
                isEmailPrescription: true
            };
        case 'existing-customer':
            return {
                isExistingCustomer: true
            };
        case 'new-prescription':
            return {
                newPrescription: swcHelpers.objectSpread({}, prescription.details)
            };
        case 'prescription-file':
            {
                const { prescriptionFile , pupillaryDistanceFile , left , right , source  } = prescription.details;
                // The server payload uses axis but it has been deprecated in favor of axisInt
                // However, the BE is not yet ready so we need to change the axisInt to axis
                const leftLens = swcHelpers.objectSpread({}, left);
                if (leftLens.axisInt) {
                    leftLens.axis = leftLens.axisInt;
                    delete leftLens.axisInt;
                }
                const rightLens = swcHelpers.objectSpread({}, right);
                if (rightLens.axisInt) {
                    rightLens.axis = rightLens.axisInt;
                    delete rightLens.axisInt;
                }
                const newPrescription = Boolean(left && right) ? {
                    leftLens,
                    rightLens,
                    source
                } : {
                    source
                };
                return {
                    newPrescription,
                    prescriptionFile: {
                        fileName: prescriptionFile.fileName,
                        storageToken: prescriptionFile.storageToken
                    },
                    pupillaryDistanceFile: pupillaryDistanceFile ? {
                        fileName: pupillaryDistanceFile.fileName,
                        storageToken: pupillaryDistanceFile.storageToken
                    } : undefined
                };
            }
    }
}
const mapPrescriptionGlassesLineItem = ({ sku , quantity , bundleLineItems , prescription  })=>{
    const mainBundleLineItem = {
        sku,
        quantity: 1,
        isMainBundleLineItem: true
    };
    var _quantity;
    return {
        sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: Types.LineItemType.BUNDLE,
        bundleLineItemsType: Types.BundleLineItemType.PRESCRIPTION_GLASSES,
        bundleLineItems: [
            mainBundleLineItem,
            ...bundleLineItems.map((item)=>swcHelpers.objectSpread({}, item, {
                    quantity: (_quantity = item.quantity) !== null && _quantity !== void 0 ? _quantity : 1,
                    isMainBundleLineItem: false
                })
            ), 
        ],
        typeDetails: getPrescriptionGlassesDetails(prescription)
    };
};

export { mapPrescriptionGlassesLineItem };
//# sourceMappingURL=prescription-glasses.js.map
